import * as React from "react";
import { Row, Col } from "antd";
import { ForwardOutlineButton } from "./ForwardOutlineButton";
import styled from "styled-components";

const Label = styled.span`
  font-size: 14px;
  font-weight: 300;
  color: ${(props: LabelProps) => (props.isDisabled ? "#6a7583" : "#386ee8")};
`;

type LabelProps = {
  isDisabled: boolean;
};

type Props = {
  isDisabled: boolean;
  onClick?: () => void;
  href?: string;
  target?: string;
  title: string;
  icon: React.JSXElementConstructor<React.StyleHTMLAttributes<{}>>;
};

export const ForwardQuickActionButton: React.FC<Props> = props => {
  const { isDisabled, title } = props;
  return (
    <Row type="flex" justify="center">
      <Col span={24} style={{textAlign: "center", marginBottom: 14}}>
        <ForwardOutlineButton {...props} />
      </Col>
      <Col span={24} style={{textAlign: "center"}}>
        <Label isDisabled={isDisabled}>{title}</Label>
      </Col>
    </Row>
  );
};
